import { isEnabled } from '@helpers/utility'

/**
 * Product gates for the Calls surface (RP-2758).
 *
 * The Calls tab, the sidebar entry and the call bubbles are shown to merchants who own either the
 * voice agent (`csa-voice`) or the stand-alone Call Notes product (`call-notes`). Only the voice-agent
 * specific UI (AI KPI cards, booking column, settings tab, subscription card) stays on `csa-voice`.
 */
export const hasCallsSurface = (products: unknown): boolean =>
  isEnabled('csa-voice', products) || isEnabled('call-notes', products)

export const hasVoiceAgent = (products: unknown): boolean => isEnabled('csa-voice', products)
